import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.StatementEmailTemplate.UploadAttachment.IRequest;
type Response = Api.Core.StatementEmailTemplate.UploadAttachment.IResponse;
type Headers = Api.Core.StatementEmailTemplate.UploadAttachment.IHeaders;
const apiStatementEmailTemplateUploadAttachmentPath = '/api/Management/StatementEmailTemplate/:id/UploadAttachment';
export default async function statementEmailTemplateUploadAttachmentApi(
  id: number,
  request: Request
): Promise<Api.Res<Response>> {
  const res = await executeServerApi<Request, Response, Headers>({
    body: request,
    url: createPathFromRoute(apiStatementEmailTemplateUploadAttachmentPath, { id }, null),
    method: HttpMethod.post,
    headers: getDefaultHeaders(),
  });
  return res;
}
